var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper-sidebar-for-me"},[_c('h2',[_vm._v(_vm._s(_vm.$tc(`${_vm.base}.title`, !_vm.isMobile)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }